import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import { useParams } from "react-router-dom";

import { PublicCensusPage } from "./PublicCensusPage";

/** Public capability reads must not be removed by an unrelated auth bootstrap. */
export function PublicCensusRoute() {
  const { token = "" } = useParams<{ token: string }>();
  return <PublicCensusScope key={token} />;
}

function PublicCensusScope() {
  const [client] = useState(
    () => new QueryClient({ defaultOptions: { queries: { staleTime: 30_000, retry: false } } }),
  );
  return (
    <QueryClientProvider client={client}>
      <PublicCensusPage />
    </QueryClientProvider>
  );
}
